import { ActionDescriptor } from '../common/commonTypes';
import DescribeAttributeForm from './DescribeAttributeForm';

const describeAttribute: ActionDescriptor = {
	FormComponent: DescribeAttributeForm,
	actionTitle: 'Describe',
};

export default describeAttribute;
